import Client from '../HttpClient';

const baseUrl = '/mole-api/s3-presign';

/**
 * Generic S3 list. `prefix` is required and identifies the S3 sub-directory
 * (e.g. `kiosk-order-evidence`). The server enforces multi-tenant scoping
 * via `merchantId` / `branchId(s)` and an optional `machineId` filter.
 *
 * @param {{
 *   prefix: string,
 *   merchantId: string,
 *   branchId?: string,
 *   branchIds?: string,
 *   machineId?: string,
 *   start?: string,
 *   end?: string,
 *   limit?: number,
 * }} params
 */
const list = (params) => Client.get(`${baseUrl}/list`, params);

export default {
	list,
};
